var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30766",
    "data-name": "Group 30766",
    transform: "translate(-1027 -522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1068",
    "data-name": "Ellipse 1068",
    transform: "translate(1027 522)",
    fill: "#62ada1",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67880",
    "data-name": "Path 67880",
    d: "M13.587.6,5.921,8.268A3.123,3.123,0,0,0,5,10.491v.844a.629.629,0,0,0,.629.629h.844A3.123,3.123,0,0,0,8.7,11.043l7.666-7.666a1.965,1.965,0,0,0,0-2.776,2.008,2.008,0,0,0-2.776,0Zm1.886,1.886L7.807,10.154a1.9,1.9,0,0,1-1.334.552H6.258v-.216A1.9,1.9,0,0,1,6.81,9.157l7.666-7.666a.722.722,0,0,1,1,0,.706.706,0,0,1,0,1Z",
    transform: "translate(1031.031 530.996)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.67ef96bbf090c74247479ec600be3bfe.svg";
export { ForwardRef as ReactComponent };